export function mapsGoogleCoordinateUrl(latitude: string, longitude: string) {
  return `https://www.google.com/maps/@${latitude},${longitude},18z`;
}
